import React, { Component } from "react";
import Alert from "sweetalert-react";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";
import Loading from "../../../../components/Loading";
import ReportChild from "../ReportChild";
import { MenuItem, DropdownButton } from "react-bootstrap";
const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  approval_by: "Approver",
};

class ReportTable extends Component {
  interval = null;
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
  };

  batchWillDelete = null;

  componentDidMount() {
    this.getListFile();
    this.interval = setInterval(() => {
      this.getListFile();
    }, 10000);
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  getListFile = () => {
    Http.getListBatch(Business.COMPONENT.CAR, null).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (!element) continue;
          if (!element.file_name.startsWith("CAR")) continue;
          element.timestamp = new Date(element.upload_time).getTime();
          listData.push(element);
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        const calculatedReports = JSON.parse(localStorage.getItem("calculated_reports")) || [];
        this.setState({
          items: [...calculatedReports, ...listData],
          loading: false,
        });
      }
    });
  };

  deleteListItems = () => {
    Http.deleteBatch(Business.COMPONENT.CAR, this.batchWillDelete).then(
      (res) => {
        if (res.Success) {
          this.getListFile();
        }
      }
    );
    this.batchWillDelete = null;
  };

  search = () => {
    const objSearch = {
      report_date:
        this.state.searchOption === "report_date"
          ? this.state.searchValue
          : null,
      file_name:
        this.state.searchOption === "file_name" ? this.state.searchValue : null,
      approval_by:
        this.state.searchOption === "approval_by"
          ? this.state.searchValue
          : null,
    };

    Http.getListBatch(Business.COMPONENT.CAR, objSearch).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (!element) continue;
          if (!element.file_name.startsWith("CAR")) continue;
          element.timestamp = new Date(element.upload_time).getTime();
          listData.push(element);
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        this.setState({
          items: listData,
          loading: false,
        });
      }
    });
  };

  onDelete = (reportName) => {
    this.batchWillDelete = reportName;
    this.setState({
      showDeleteAlert: true,
    });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT]) && (
        <div className="card">
          <div className="header" style={{ marginBottom: "10px", gap: 16 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#757575",
                fontSize: 16,
              }}
            >
              <p style={{ marginBottom: 0 }}>CAR</p>
              <p style={{ marginBottom: 0 }}>/</p>
              <p style={{ color: "#BF6A02", marginBottom: 0 }}>Report IRB</p>
            </div>
            <h4 className="title" style={{ fontSize: 20 }}>
              Report IRB Management
            </h4>
          </div>
          <div className="content table-responsive table-full-width">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px",
                gap: 8,
              }}
            >
              <input
                type="text"
                style={{
                  height: "44px",
                  flex: 1,
                  backgroundColor: "#ffffff",
                  border: "1px solid #D9D9D9",
                  borderRadius: 8,
                }}
                className="form-control"
                id="search_content"
                onChange={(event) => {
                  this.setState({ searchValue: event.target.value });
                }}
                placeholder="Search report name"
              />
              <div style={{ display: "inline" }}>
                <DropdownButton
                  title={<i className="pe-7s-filter"></i>}
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                  style={{
                    height: 44,
                    border: "1px solid #767676",
                    borderRadius: 8,
                    color: "#1E1E1E",
                    backgroundColor: "#E3E3E3",
                  }}
                >
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`approval_by`}
                  >
                    {"Approver"}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`file_name`}
                  >
                    {"Report Name"}
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={(eventKey, event) => {
                      this.setState({ searchOption: eventKey });
                    }}
                    eventKey={`report_date`}
                  >
                    {"Report Date"}
                  </MenuItem>
                  <MenuItem divider />
                </DropdownButton>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#1E1E1E",
                }}
              >
                <button
                  type="button"
                  disabled={this.state.progressValue > 0}
                  className="btn btn-primary"
                  style={{
                    color: "#1E1E1E",
                    backgroundColor: "#E3E3E3",
                    borderRadius: "8px",
                    fontSize: 16,
                    fontWeight: 400,
                    marginLeft: "auto",
                    float: "left",
                    height: "44px",
                    border: "1px solid #767676",
                  }}
                  onClick={() => this.search()}
                >
                  <i
                    className="pe-7s-search"
                    style={{ fontSize: 16, marginRight: 8 }}
                  ></i>
                  Search
                </button>
              </div>
            </div>
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>Report Date</th>
                  <th>Report Name</th>
                  <th>Approver</th>
                  <th>Approval Time</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.items.map((item) => (
                  <tr key={item.file_name}>
                    <td>{Business.convertToDate(item.report_date)}</td>
                    <td>
                      <ReportChild report={item} type="irb" />
                    </td>
                    <td>{item.approval_by}</td>
                    <td>{Business.convertToFullDate(item.approval_time)}</td>
                    <td>{item.upload_by}</td>
                    <td>{Business.convertToFullDate(item.upload_time)}</td>
                    <td className="text-right">
                      <div className="buttons-container">
                        {Business.isHasRole([
                          Business.ROLE_DEFINE_MAP.CAR_DELETE_REPORT,
                        ]) ? (
                          <a
                            rel="tooltip"
                            aria-disabled="true"
                            className="btn btn-info btn-simple btn-xs delete-button"
                            data-original-title="View Profile"
                            onClick={() => this.onDelete(item.file_name)}
                          >
                            <i
                              style={{ fontSize: 20, color: "#535862" }}
                              className="pe-7s-trash"
                            ></i>
                          </a>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Alert
            title="Are you sure?"
            show={this.state.showDeleteAlert}
            text="You will not be able to recover this report!"
            showCancelButton
            onConfirm={() => {
              this.setState({ showDeleteAlert: false });
              this.deleteListItems();
            }}
            onCancel={() => {
              this.setState({ showDeleteAlert: false });
              this.batchWillDelete = null;
            }}
          />
        </div>
      )
    );
  }
}

export default ReportTable;



// WEBPACK FOOTER //
// ./src/pages/CAR/Reports/ReportIRB/ReportTable.js